import { adjustmentApi, mockDataApi, } from '@/api';
import QueryParameterBuilder from '@/lib/query-parameter/QueryParameterBuilder';
import { injectSortParamHelper } from '@/lib/query-parameter/sortby';
import PaginationOutput from '@/helpers/PaginationOutput';
export default {
    async getStoreAdjustment(hubId, { fromAt, toAt, pageNumber, pageSize, sortOption = [], storeName, }) {
        const params = new QueryParameterBuilder()
            .addFromAt(fromAt)
            .addToAt(toAt)
            .addPageNumber(pageNumber)
            .addPageSize(pageSize)
            .addStoreName(storeName);
        injectSortParamHelper(params, sortOption);
        const response = await adjustmentApi.getStoreAdjustment(hubId, params.build());
        return PaginationOutput.adaptorFactory(response);
    },
    async getStoreAdjustmentDetail({ storeId, hubId, fromAt, toAt, }) {
        const params = new QueryParameterBuilder()
            .addFromAt(fromAt)
            .addToAt(toAt);
        const response = await adjustmentApi.getStoreAdjustmentDetail(hubId, storeId, params.build());
        return response.data;
    },
    async getWorkerAdjustmentWithhold({ hubId, fromAt, toAt, }) {
        const params = new QueryParameterBuilder()
            .addFromAt(fromAt)
            .addToAt(toAt);
        const response = await adjustmentApi.getWorkerAdjustmentWithhold(hubId, params.build());
        return response.data;
    },
    async getBasicBaromoneyReport(hubId, { fromAt, toAt, }) {
        const params = new QueryParameterBuilder()
            .addFromAt(fromAt)
            .addToAt(toAt);
        const response = await adjustmentApi.getBasicBaromoneyReport(hubId, params.build());
        return response.data;
    },
    async getDetailsPerWorkerList() {
        const params = new QueryParameterBuilder();
        const response = await mockDataApi.getDetailsPerWorkerList(params.build());
        return PaginationOutput.adaptorFactory(response);
    },
    async getHubMainReport(hubId, { fromAt, toAt, }) {
        const params = new QueryParameterBuilder()
            .addFromAt(fromAt)
            .addToAt(toAt);
        const response = await adjustmentApi.getHubMainReport(hubId, params.build());
        return response.data;
    },
    /**
     * 허브 정산 - 타입별 정산 내역서 조회
     */
    async getHubAdjustmentReportByType(hubId, reportType, fromAt, toAt, storeType, keyword, orderMetricsDailyConditionType) {
        // 단일 페이지로 사용하므로 모든 데이터 도출되어야 함.
        const params = new QueryParameterBuilder()
            .addPageSize(10000);
        if (fromAt && toAt) {
            params
                .addFromAt(fromAt)
                .addToAt(toAt);
        }
        if (storeType) {
            params
                .add('storeType', storeType);
        }
        if (orderMetricsDailyConditionType) {
            params
                .add('orderMetricsDailyConditionType', orderMetricsDailyConditionType);
        }
        if (keyword) {
            params
                .add('keyword', keyword);
        }
        const response = await adjustmentApi.getHubAdjustmentReportByType(hubId, reportType, params.build());
        return response.data;
    },
};
